module.exports = __webpack_public_path__ + "img/logo.de87ac1b.png";